module.exports = __webpack_public_path__ + "static/media/INDUSTOWER_F1.64bef62d.txt";